export default __webpack_public_path__ + "fec5e65035ad8f4c1a32f8ec71513594.svg";